'use strict';

var DataExtractConstants = {
  VIEW: {
    SCHEDULED: 'scheduled',
    COMPLETED: 'completed',
    NEW_EXTRACT: 'new-extract'
  },
  OCCURRENCE: {
    NOW: 'now',
    LATER: 'later'
  },
  PROCESSING_TYPES: {
    CURVE: 'CURVE',
    JOIN: 'JOIN',
    NONE: 'NONE',
    BID_PRICE: 'BID_PRICE'
  },
  RECURRENCE: {
    INDEFINITELY: 'repeatIndefinitely',
    TIMES: 'repeatTimes',
    UNTIL: 'repeatUntil'
  },
  DAYS_OF_MONTH: function () {
    var days = [];
    for (var i = 1; i <= 31; i++) {
      days.push({
        id: i,
        label: i
      });
    }
    days.push({
      id: 0,
      label: 'Last day of month'
    });
    return days;
  }(),
  ACTION_TYPES: {
    CREATE: 'create',
    UPDATE: 'update'
  },
  RECURRENCE_INTERVALS: [{
    id: 'Days',
    label: 'Daily'
  }, {
    id: 'Weeks',
    label: 'Weekly'
  }],
  CALENDAR_INTERVALS: ['Weekly', 'Monthly'],
  SAVE_OPTION: {
    FTP: 'FTP'
  },
  EMAIL_RECIPIENTS_PATTERN: /^([!#\$%&'\*\+\-/=\?\^_`{\|}~\.a-zA-Z0-9]+@[!#\$%&'\*\+\-/=\?\^_`{\|}~\.a-zA-Z0-9]+)(\s*,\s*([!#\$%&'\*\+\-/=\?\^_`{\|}~\.a-zA-Z0-9]+@[!#\$%&'\*\+\-/=\?\^_`{\|}~\.a-zA-Z0-9]+))*$/
};
module.exports = DataExtractConstants;